<template>
  <ul @click="closeSweetAlert">
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in navMenuItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { provide, ref } from '@vue/composition-api'
import { eventBus } from '@/main'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'
import VerticalNavMenuGroup from '../vertical-nav-menu-group/VerticalNavMenuGroup.vue'

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    // items: {
    //   type: Array,
    //   required: true,
    // },
  },
  methods: {
    /* close alert we click in sidebar */
    closeSweetAlert() {
      /* to close user profile */
      this.$store.state.app.isUserProfileOpen = false
      eventBus.$emit('closeSweetAlert', true)
    },
  },
  setup() {
    provide('openGroups', ref([]))
    return {
      resolveNavItemComponent,
    }
  },
}
</script>
